module.exports = __webpack_public_path__ + "static/media/logo.156f8a86.svg";